// extracted by mini-css-extract-plugin
module.exports = {"Timer":"Timer_Timer__KDqHh"};